import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API дефектов для заключений технических устройств
 */
@Injectable()
export class DefectApiService extends ApiService {
    baseUrl = 'defect';
}
